import React, {Component} from 'react';
import './StepTime.css';
import closeDoctorFilterIcon from "../../img/closeDoctorFilter.png";
import Userpic from '../../img/Userpic.jpg';
import infoIco from '../../img/comfortAlert.png';
import ApiConnector from '../api/ApiConnector'
import GlobalStore from "../../store/GlobalStore";
import FilterDoctor from "./FilterDoctor";
import FilterCalendar from "./FilterCalendar";
import 'react-notifications/lib/notifications.css';
import {NotificationContainer, NotificationManager} from 'react-notifications';
import 'moment-timezone';
import TagManager from 'react-gtm-module';
import {config} from '../../config.js';
import ReactQueryParams from 'react-query-params';
import {Animated} from "react-animated-css";

const monthNames = ["Tammikuu", "Helmikuu", "Maaliskuu", "Huhtikuu", "Toukokuu", "Kesäkuu", "Heinäkuu", "Elokuu", "Syyskuu", "Lokakuu", "Marraskuu", "Joulukuu"];
const daysName = ['Sunnuntai', 'Maanantai', 'Tiistai', 'Keskiviikko', 'Torstai', 'Perjantai', 'Lauantai'];
let timersForFindFreeDay = [];

class StepTime extends ReactQueryParams {
    constructor(props) {
        super();
        this.freeTimeClick = this.freeTimeClick.bind(this);
        this.openDoctorFilter = this.openDoctorFilter.bind(this);
        this.openCalendarFilter = this.openCalendarFilter.bind(this);
        this.openCurrentTab = this.openCurrentTab.bind(this);
        this.disableFilterDoctor = this.disableFilterDoctor.bind(this);
        this.openPrevDate = this.openPrevDate.bind(this);
        this.openNextDate = this.openNextDate.bind(this);
        this.openDateFromCalendar = this.openDateFromCalendar.bind(this);
        this.getDoctorList = this.getDoctorList.bind(this);
        this.state = {
            ApiTimeList: [],
            stepTimeProcessor: 'filterDoctor',
            activeDateTextFormat: '',
            counterForDate: 0,
            activeFilterDoctor: null,
            loader: true,
            lastFreeDayCount: 0,
            doctorList: undefined,
            currentDateForInfoPercentage: [],
            currentDayFreeSlotsCount: 0,
            futureDayFreeSlotsCount: 0,
            ifShowPercentageBlock: false,
            isSlotsAvailable2WeeksFromNow: false,
            bookedVisitsPercentage: 0
        };
    }

    showStep() {

        switch (this.state.stepTimeProcessor) {
            case 'default':
                return (
                    <div>
                        <div className="selectTimeNavigation">
                            {(this.state.counterForDate !== 0) ?
                                <div className="selectTimeNavigationBefore" onClick={this.openPrevDate}></div> :
                                <div className="selectTimeNavigationBefore disableButton"></div>}
                            {(this.state.counterForDate < this.state.lastFreeDayCount) ?
                                <div className="selectTimeNavigationAfter" onClick={this.openNextDate}></div> :
                                <div className="selectTimeNavigationAfter disableButton"></div>}
                            <div className="selectTimeNavigationTitle">{this.state.activeMonthString}</div>
                            {/*///TODO: put day of the week here*/}
                            <div className="selectTimeNavigationCurrentDate">{this.state.activeDateTextFormat}</div>
                            {(this.state.activeFilterDoctor !== null) ?
                                <div className="activeFilterDoctor"><span>{this.state.activeFilterDoctor}<img
                                    onClick={this.disableFilterDoctor} alt="closeDoctorFilterIcon"
                                    src={closeDoctorFilterIcon}/></span></div> : ''}
                        </div>

                        {(this.state.ifShowPercentageBlock === true) ?
                            <Animated animationIn="fadeIn" animationOut="fadeOut" isVisible={true}>
                                <div className="col-xs-12 bookingPercentageInfoContainer">
                                    <div className="bookingPercentageInfo">
                                        <img src={infoIco} alt="infoIco"/><span>Enää {this.state.bookedVisitsPercentage}%  jäljellä päivän kaikista ajoista.</span>
                                    </div>
                                </div>
                            </Animated> : ''}


                        <div className="selectTimeList col-xs-12">
                            {(this.state.loader === true) ? <div className="localLoader">
                                <div className="localSpinner"></div>
                            </div> : ''}
                            {this.state.ApiTimeList}
                        </div>
                    </div>
                );
            case 'filterDoctor':
                return (
                    <FilterDoctor getDoctorList={this.getDoctorList} openCurrentTab={this.openCurrentTab}
                                  disableFilterDoctor={this.disableFilterDoctor}/>
                );
            case 'filterCalendar':
                return (
                    <FilterCalendar activeFilterDoctor={this.state.activeFilterDoctor}
                                    disableFilterDoctor={this.disableFilterDoctor}
                                    openDateFromCalendar={this.openDateFromCalendar}/>
                );
        }
    }

    clearFreeDayTimer() {
        timersForFindFreeDay.forEach((timeoutId) => {
            window.clearTimeout(timeoutId);
        });
        timersForFindFreeDay = [];
    }

    getDoctorList(objectDoctorList) {
        this.setState({
            doctorList: objectDoctorList
        }, () => {
            this.componentDidMount();
        });
    }

    openPrevDate() {
        this.clearFreeDayTimer();
        this.setState({
            counterForDate: this.state.counterForDate - 1,
            loader: true,
            ifShowPercentageBlock: false
        }, () => {
            this.componentDidMount();
        });
    }

    openNextDate() {
        this.clearFreeDayTimer();
        this.setState({
            counterForDate: this.state.counterForDate + 1,
            loader: true,
            ifShowPercentageBlock: false
        }, () => {
            this.componentDidMount();
        });
    }

    openDateFromCalendar(resultGetDayDelta) {
        this.setState({
            counterForDate: resultGetDayDelta,
            stepTimeProcessor: 'default',
            loader: true
        }, () => {
            this.componentDidMount();
        });
    }

    getDayDelta(incomingDate, todayDate) {
        let oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
        return Math.round(Math.abs((incomingDate.getTime() - todayDate.getTime()) / (oneDay)));
    }

    getFreeSlots(currentDate) {
        let lastHourCurrentDate = new Date();
        let currentDay = currentDate.getDate();
        let currentMonth = currentDate.getMonth() + 1;
        let currentYear = currentDate.getFullYear();

        if (currentDay < 10) {
            currentDay = '0' + currentDay;
        }
        if (currentMonth < 10) {
            currentMonth = '0' + currentMonth;
        }

        let currentDayMyFormat = "" + currentYear + "-" + currentMonth + "-" + currentDay + "+00%3A00";

        lastHourCurrentDate.setFullYear(currentYear + 1);
        lastHourCurrentDate = lastHourCurrentDate.toJSON();

        let filterDoctorId;
        let currentSubCategoryId = GlobalStore.getInstance().data['categories'];
        let currentStateFilterDoctorId = GlobalStore.getInstance().data['filterDoctorId'];
        let officeId = GlobalStore.getInstance().data['office'];
        if (currentStateFilterDoctorId != null) {
            filterDoctorId = currentStateFilterDoctorId;
        }

        return ApiConnector.getTimeList(currentSubCategoryId, currentDayMyFormat, lastHourCurrentDate, filterDoctorId, 'Days', officeId);
    }

    blockNavigationAfterLastFreeSlotsDay(currentDate) {
        let getApiTimeList = this.getFreeSlots(currentDate);
        getApiTimeList
            .then(data => {
                if(data.length) {
                    let lastFreeDay = data.length - 1;
                    let nearestFreeDate = this.stabilizationDateForSafari(data[lastFreeDay].Day);
                    nearestFreeDate.setHours(0, 0, 0);
                    let currentDate = new Date();
                    currentDate.setHours(0, 0, 0);
                    let resultGetDayDelta = this.getDayDelta(nearestFreeDate, currentDate);
                    this.setState({lastFreeDayCount: resultGetDayDelta});
                }
            }).catch((reason) => {
                console.log(reason)

                this.setState({loader: false});
                NotificationManager.warning('Pyyntö evätty internet-yhteysongelman vuoksi. Klikkaa tästä lähettääksesi pyyntö uudelleen', 'Yhteysongelma', 10000, () => {
                    this.componentDidMount();
                });
        });
    }

    openDateIfCurrentDayEmpty(currentDate) {
        let getApiTimeList = this.getFreeSlots(currentDate);
        getApiTimeList
            .then(data => {
                if(data.length) {
                    let nearestFreeDate = this.stabilizationDateForSafari(data[0].Day);
                    nearestFreeDate.setHours(0, 0, 0);
                    let currentDate = new Date();
                    currentDate.setHours(0, 0, 0);
                    let resultGetDayDelta = this.getDayDelta(nearestFreeDate, currentDate);
                    this.setState({counterForDate: resultGetDayDelta}, () => {
                        this.componentDidMount();
                    });
                }
            }).catch(() => {
            this.setState({loader: false});
            NotificationManager.warning('Pyyntö evätty internet-yhteysongelman vuoksi. Klikkaa tästä lähettääksesi pyyntö uudelleen', 'Yhteysongelma', 10000, () => {
                this.componentDidMount();
            });
        });
    }

    shouldComponentUpdate(nextProps, nextState) {
        return (this.state.counterForDate !== nextState.counterForDate || this.state.counterForDate !== null);
    }

    disableFilterDoctor() {
        this.setState({
            activeFilterDoctor: null,
            loader: true
        });
        GlobalStore.getInstance().data['filterDoctorId'] = null;
        GlobalStore.getInstance().data['filterDoctorName'] = null;
        this.componentDidMount();
    }

    openDoctorFilter() {
        this.clearFreeDayTimer();
        if (this.state.stepTimeProcessor === 'filterDoctor') {
            this.setState({
                stepTimeProcessor: 'default'
            }, () => {
                this.componentDidMount();
            });
        } else {
            this.setState({
                stepTimeProcessor: 'filterDoctor'
            });
        }
    }

    openCalendarFilter() {
        this.clearFreeDayTimer();
        if (this.state.stepTimeProcessor === 'filterCalendar') {
            this.setState({
                stepTimeProcessor: 'default'
            }, () => {
                this.componentDidMount();
            });
        } else {
            this.setState({
                stepTimeProcessor: 'filterCalendar'
            });
        }
    }

    openCurrentTab() {
        this.setState({
            stepTimeProcessor: 'default',
            loader: true
        });
        this.componentDidMount();

    }

    generateActiveDayString(currentDate) {
        let currentDay = currentDate.getDate();
        let currentMonth = currentDate.getMonth() + 1;
        let currentYear = currentDate.getFullYear();

        if (currentDay < 10) {
            currentDay = '0' + currentDay;
        }
        if (currentMonth < 10) {
            currentMonth = '0' + currentMonth;
        }

        return (
            <div><span>{daysName[currentDate.getDay()]} </span>{currentDay + '.' + currentMonth + '.' + currentYear}
            </div>
        );
    }

    convertMinutesWithLeadingZeros(timeForConvert) {
        return (timeForConvert.getMinutes() < 10 ? '0' : '') + timeForConvert.getMinutes();
    }

    stabilizationDateForSafari(date) {
        let arr = date.split(/[- :T]/);
        return new Date(arr[0], arr[1] - 1, arr[2], arr[3], arr[4], arr[5]);
    }

    componentDidMount() {
        if (this.state.doctorList !== undefined) {
            this.showFreeDay();
        }
    }


    showStatisticBookingToday() {
        let moment = require('moment');
        let currentDate = this.state.currentDateForInfoPercentage;
        let currentDateMoment = moment(currentDate);
        let currentDayAddTwoWeeks = currentDateMoment.add(14, 'days').format('LLLL');
        let currentDayAddTwoWeeksForStart = new Date(currentDayAddTwoWeeks);
        let currentDayAddTwoWeeksForEnd = new Date(currentDayAddTwoWeeks);
        let officeId = GlobalStore.getInstance().data['office'];
        currentDayAddTwoWeeksForStart.setHours(6, 0, 0);
        currentDayAddTwoWeeksForEnd.setHours(23, 59, 59);

        let getApiTimeList = ApiConnector.getTimeList(GlobalStore.getInstance().data['categories'], currentDayAddTwoWeeksForStart.toJSON(), currentDayAddTwoWeeksForEnd.toJSON(), '', 'Days',officeId);
        getApiTimeList
            .then(data => {
                this.setState({futureDayFreeSlotsCount: data[0].SlotCount});
                /**
                 * Currently it's how many percents left, not booked
                 */
                let bookedVisitsPercentage = 100 - ((this.state.futureDayFreeSlotsCount - this.state.currentDayFreeSlotsCount) / this.state.futureDayFreeSlotsCount) * 100;
                bookedVisitsPercentage = bookedVisitsPercentage.toFixed();
                this.setState({bookedVisitsPercentage: bookedVisitsPercentage});

                if (bookedVisitsPercentage >= 1 && bookedVisitsPercentage < 41 && GlobalStore.getInstance().data['filterDoctorName'] === null) {
                    this.setState({ifShowPercentageBlock: true});
                    const tagManagerArgsUniversal = {
                        dataLayer: {
                            event: 'select_content',
                            content_type: 'appointment FOMO % already booked shown',
                            content_id: new Date().toString() + ' ||| visits booked: ' + bookedVisitsPercentage + '%, doctor: ' + GlobalStore.getInstance().data['filterDoctorName']
                        }
                    };

                    if (this.queryParams.env !== "test" && config.environment === "prod") {
                        TagManager.dataLayer(tagManagerArgsUniversal);
                    }

                } else {
                    this.setState({ifShowPercentageBlock: false});
                }

            }).catch(() => {
            this.setState({ifShowPercentageBlock: false});
        });


    }

    showFreeDay() {
        let currentDate = new Date();
        let lastHourCurrentDate = new Date();
        let counterForDate = this.state.counterForDate;

        currentDate.setDate(currentDate.getDate() + counterForDate);
        lastHourCurrentDate.setDate(lastHourCurrentDate.getDate() + counterForDate);
        if (counterForDate > 0) {
            currentDate.setHours(6, 0, 0);
        }

        //записуємо поточну дату в state
        this.setState({currentDateForInfoPercentage: currentDate});
        //блокуємо стрілочку перемикача в перед на останньому доступному дні
        this.blockNavigationAfterLastFreeSlotsDay(currentDate);
        // toJSON() prints the UTC Date , meanwhile we need EET - Helsinki-timezone date, thus we shift the UTC date by necessary offset to have correct value
        let currentDateJSON =  new Date(currentDate.getTime() - (currentDate.getTimezoneOffset() * 60000)).toJSON();
        lastHourCurrentDate.setHours(23, 59, 59);
        let currentMonthString = monthNames[currentDate.getMonth()];
        lastHourCurrentDate =  new Date(lastHourCurrentDate.getTime() - (lastHourCurrentDate.getTimezoneOffset() * 60000)).toJSON();
        //викликаємо функцію для формування поточної дати у форматі December, 14.12.2017 і записуємо у state для подальшого використання
        let resultGenerateActiveDayString = this.generateActiveDayString(currentDate);
        this.setState({
            activeDateTextFormat: resultGenerateActiveDayString,
            activeMonthString: currentMonthString
        });

        let filterDoctorId;
        let currentSubCategoryId = GlobalStore.getInstance().data['categories'];
        let currentStateFilterDoctorId = GlobalStore.getInstance().data['filterDoctorId'];
        let officeId = GlobalStore.getInstance().data['office'];
        if (currentStateFilterDoctorId != null) {
            filterDoctorId = currentStateFilterDoctorId;
        }

        let getApiTimeList = ApiConnector.getTimeList(currentSubCategoryId, currentDateJSON, lastHourCurrentDate, filterDoctorId, 'Full',officeId);

        getApiTimeList
            .then(data => {
                let resultApiTimeList;
                this.setState({currentDayFreeSlotsCount: data.length}, () => {
                    this.showStatisticBookingToday();
                });
                if (data.length === 0) {
                    let timerForFindFreeDay = setTimeout(() => {
                        this.openDateIfCurrentDayEmpty(currentDate);
                    }, 1000);
                    timersForFindFreeDay.push(timerForFindFreeDay);
                    resultApiTimeList = (
                        <div className="selectTimeItem emptyDay" key={Math.random()}>Tälle päivälle ei ole enää vapaita
                            aikoja. Näytämme seuraavat vapaat ajat. Odota 2 sekuntia.
                            <div className="load-wrapp">
                                <div className="load-3">
                                    <div className="line"></div>
                                    <div className="line"></div>
                                    <div className="line"></div>
                                </div>
                            </div>
                        </div>
                    )
                } else {
                    resultApiTimeList = data.map((item) => {
                        // console.log(item);

                        let getFreeTime = this.stabilizationDateForSafari(item.StartTime);
                        let currentFreeTimeString = getFreeTime;

                        let getMinutes = this.convertMinutesWithLeadingZeros(getFreeTime);
                        getFreeTime = `${getFreeTime.getHours()}:${getMinutes}`;

                        function isDoctorIdMatching(doctor) {
                            return doctor.doctorId === item.ResourceId;
                        }

                        let allDoctorsObject = this.state.doctorList;
                        // console.log(this.state.doctorList);

                        if (typeof allDoctorsObject.find(isDoctorIdMatching) == 'undefined') {
                            return;
                        }

                        let currentDoctorName = allDoctorsObject.find(isDoctorIdMatching).doctorName;
                        let currentDoctorImgUrl = allDoctorsObject.find(isDoctorIdMatching).doctorImageUrl;

                        if (currentDoctorImgUrl === null) {
                            currentDoctorImgUrl = Userpic;
                        }

                        let office = GlobalStore.getInstance().data['officesList'][item.BranchId];
                        let freeTimeClickProcessor = this.freeTimeClick.bind(this, item.BranchId, getFreeTime, currentDoctorName, item.Length, currentDate, item.ResourceId, item.StartTime, item.EndTime, item.ReasonId, currentFreeTimeString);

                        return (
                            <div className="col-md-6 col-xs-12" key={Math.random()}>
                                <div className="selectTimeItem" onClick={freeTimeClickProcessor}>
                                    <span className="ripplesCircle"></span>
                                    <div className="col-xs-3 freeTime">
                                        <div className="selectTimeItemTitle">Aika</div>
                                        <div className="selectTimeItemBold">{getFreeTime}</div>
                                    </div>
                                    <div className="col-xs-6">
                                        <div className="selectTimeItemTitle">Hoitohenkilö</div>
                                        <div className="selectTimeItemRegular">{currentDoctorName}</div>

                                        <div className="selectTimeItemOfficeName">{office.Name}</div>
                                        <div className="selectTimeItemOfficeAddress">{[office.Address.Street,office.Address.PostalCode,office.Address.City,office.Address.Country].join(', ')+'.'}</div>
                                    </div>
                                    <div className="col-xs-3">
                                        {/*<div className="selectTimeItemTitle">Kesto</div>*/}
                                        <div className="selectTimeItemRegular"><img src={currentDoctorImgUrl}
                                                                                    alt="doctorImage"/></div>
                                    </div>
                                </div>
                            </div>
                        )
                    });
                }
                this.setState({ApiTimeList: resultApiTimeList, loader: false});
                if (GlobalStore.getInstance().data['filterDoctorName'] !== undefined) {
                    this.setState({activeFilterDoctor: GlobalStore.getInstance().data['filterDoctorName']});
                }
            }).catch((reason) => {
            console.log(reason)
            this.setState({loader: false});
            NotificationManager.warning('Pyyntö evätty internet-yhteysongelman vuoksi. Klikkaa tästä lähettääksesi pyyntö uudelleen', 'Yhteysongelma', 10000, () => {
                this.componentDidMount();
            });
        });
    }

    componentDidUpdate(prevProps, prevState) {
        // clearTimeout(this.state.timerForFindFreeDay);
    }

    freeTimeClick(BranchId, activeFreeTime, activeDoctorName, activeLength, activeCurrentDate, ResourceId, StartTime, EndTime, ReasonId, currentFreeTimeString) {
        let objectTime = {
            BranchId: BranchId,
            activeFreeTime: activeFreeTime,
            activeDoctorName: activeDoctorName,
            activeLength: activeLength,
            activeDayName: daysName[activeCurrentDate.getDay()],
            ResourceId: ResourceId,
            StartTime: StartTime,
            EndTime: EndTime,
            ReasonId: ReasonId,
            currentFreeTimeString: currentFreeTimeString
        };
        GlobalStore.getInstance().data['stepTimeData'] = objectTime;
        this.props.nextStep();
    }

    render() {
        //  TODO: слід провести рефакторинг і зменшити кількисть рендерів основного компонента, а саме зменшети кількисть змін станів і обєднати у 1 функцію
        let currentStepTimeProcessor = this.state.stepTimeProcessor;
        return (
            <div className="stepDoctor col-xs-12">
                <div className="filterContainer col-xs-12">
                    <div className="col-xs-6 filterContainerLeftPart">
                        <div
                            className={`openDoctorFilter ${(currentStepTimeProcessor === 'filterDoctor') ? 'activeFilterTab' : ''}`}
                            onClick={this.openDoctorFilter}><span className="ripplesCircle"></span>Hoitava henkilö
                        </div>
                    </div>
                    <div className="col-xs-6 filterContainerRightPart">
                        <div
                            className={`openCalendarFilter ${(currentStepTimeProcessor === 'filterCalendar') ? 'activeFilterTab' : ''}`}
                            onClick={this.openCalendarFilter}><span className="ripplesCircle"></span>Päivämäärä
                        </div>
                    </div>
                </div>

                <div className="selectTimeContainer col-xs-12">
                    {this.showStep()}
                </div>

                <NotificationContainer/>

            </div>
        );
    }

}

export default StepTime;



// WEBPACK FOOTER //
// ./src/components/Step_3/StepTime.jsx